module.exports = __webpack_public_path__ + "img/setting-not.00dfc711.jpg";